import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './work.order.routing';
import { AppComponent } from '../app.component';
import { ListComponent, WorkOrderResourceDialog } from './list/list.component';

import { AuthGuard } from '../auth.guard';
import { WorkOrderService } from './services/work.order.service';
import { DateService } from '../shared/services/date.service';
import { RouterModule } from '@angular/router';
import { DesktopListComponent } from './list/list-desktop/list-desktop.component';
import { MobileListComponent } from './list/list-mobile/list-mobile.component';
import { LaborDialog } from './labor-dialog/labor.dialog';
import { WorkOrderPrintDialog } from './work-order-print-dialog/work-order-print-dialog.component';
import { DatesValidatorDirective } from './directives/datesValidatot.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forRoot(routing, {}),
        SharedModule
    ],
  declarations: [ListComponent, DesktopListComponent, MobileListComponent, WorkOrderResourceDialog, LaborDialog, WorkOrderPrintDialog, DatesValidatorDirective],
    exports: [],
    providers: [AppComponent, AuthGuard, WorkOrderService, DateService]
})
export class WorkOrderModule { }
